import { render } from "./ActivityPage.vue?vue&type=template&id=09ffcc12&scoped=true"
import script from "./ActivityPage.vue?vue&type=script&lang=js"
export * from "./ActivityPage.vue?vue&type=script&lang=js"

import "./ActivityPage.vue?vue&type=style&index=0&id=09ffcc12&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ffcc12"]])

export default __exports__